export default __webpack_public_path__ + "static/media/tab_unselected.cd8085f5.svg";